import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
import { isPage, isMobile } from "./lib/util";
import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin); // グローバルに一度だけ登録

// スクロールして数値をカウントアップ
const gsapInit = () => {
  const targets = document.querySelectorAll('.js-countUp-target');

  if (!targets.length) {
    console.warn('js-countUp-target が見つかりません');
  }

  targets.forEach((target) => {
    const trigger = target.closest('.trigger');

    if (!trigger) {
      console.warn('trigger 要素が見つかりません for', target);
      return;
    }

    const from = parseInt(target.dataset.from, 10) || 0;
    const to = parseInt(target.dataset.to, 10) || 0;
    const numObj = { count: from };

    gsap.to(numObj, {
      count: to,
      duration: 1,
      ease: 'none',
      scrollTrigger: {
        trigger: trigger,
        start: 'top 80%',
        toggleActions: 'play none none none',
        once: true,
      },
      onUpdate: () => {
        target.textContent = Math.floor(numObj.count);
      }
    });
  });


  gsap.registerPlugin(ScrollTrigger);
  // 改行系テキストスクロール制御
// 改行系テキストスクロール制御
  const downElements = document.querySelectorAll('.down');
  downElements.forEach(lead => {
    if (!lead.querySelector('span')) {
      const lines = lead.innerHTML.split('<br>');
      lead.innerHTML = lines.map(line => `<span>${line.trim()}</span>`).join('<br>');
    }

    const lines = lead.querySelectorAll('span');
    if (!lines.length) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: lead,
        start: 'top 80%',
        end: 'bottom 30%',
        once: true,
      }
    });

    lines.forEach((line, i) => {
      tl.fromTo(line,
        { y: -30, autoAlpha: 0 },
        { y: 0, autoAlpha: 1, duration: 0.6, ease: 'power2.out' },
        `-=${0.2 * i}`
      );
    });
  });

  // 汎用方向アニメーション関数
  const animateFromDirection = (selector, direction) => {
    const offset = 50;
    const transformProps = {
      left: { x: -offset },
      right: { x: offset },
      top: { y: -offset },
    };

    gsap.utils.toArray(selector).forEach((el) => {
      if (!el) return;
      gsap.from(el, {
        ...transformProps[direction],
        opacity: 0.4,
        transformOrigin: "center center",
        scrollTrigger: {
          trigger: el,
          start: 'top 100%',
          end: 'bottom center',
          scrub: 2,
        }
      });
    });
  };

  animateFromDirection('.scroll_left', 'left');
  animateFromDirection('.scroll_right', 'right');
  animateFromDirection('.scroll_top', 'top');

  // imgパララックスとブラー
  const items = gsap.utils.toArray(".img_parallax");
  items.forEach((item) => {
    if (!item) return;
    const img = item.querySelector("img");
    const beforeFake = item.querySelector(".before-fake");
    if (!img) return;

    const targets = beforeFake ? [img, beforeFake] : [img];

      gsap.fromTo(
        targets,
        { yPercent: 0 },
        {
          yPercent: -5,
          ease: "none",
          scrollTrigger: {
            trigger: item,
            start: "top 90%",
            end: "bottom top",
            scrub: 1,
          },
        }
      );

      ScrollTrigger.create({
        trigger: item,
        start: "top 90%",
        onEnter: () => item.classList.add("is-visible"),
        onLeaveBack: () => item.classList.remove("is-visible"),
      });

    });

// 曲線背景にクラス付与
gsap.utils.toArray('.icon_wrap').forEach((item) => {
  if (!item) return;

  ScrollTrigger.create({
    trigger: item,
    start: "top 50%",
    onEnter: () => {
      item.classList.add("is-show");
    },
    once: true, // ← これが重要（onEnterが1回だけ実行される）
  });
});


};

// ページ読み込み時に順序よく初期化
document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();

  // scrollEffect が Promise を返す場合を想定
  const maybePromise = scrollEffect();

  if (maybePromise instanceof Promise) {
    maybePromise.then(() => {
      gsapInit();
    });
  } else {
    // Promiseでなければ window.load 後にフォールバック
    window.addEventListener('load', () => {
      gsapInit();
    });
  }
});

// Swiper 初期化
$(function () {
  const swiper = new Swiper('.swiper', {
    slidesPerView: 4.5,
    centeredSlides: false,
    loop: true,
    spaceBetween: 0,
    autoplay: {
      delay: 3000,
    },
    scrollbar: {
      el: '.slider__scrollbar',
      draggable: true,
      snapOnRelease: false,
      dragClass: 'slider__btn',
    },
    breakpoints: {
      768: {
        slidesPerView: 4.5,
        centeredSlides: false,
      },
      0: {
  centeredSlides: true,
    slidesPerView: 1.8,
    spaceBetween: 10,
    loop: true,
      }
    }
  });
});

// contactページのみバリデーション実行
$(function () {
  if (isPage('contact')) {
    topValidation();
  }
});

// ハンバーガーメニュー＆スムーススクロール
$(function () {
  const $btnMenu = $('.btn_hd_menu');
  const $nav = $('.hd_inner_block');

  $btnMenu.on('click', function () {
    $nav.toggleClass('is-active');
    $btnMenu.toggleClass('is-open');
  });

  $('[href^="#"]').on('click', function (event) {
    const id = $(this).attr('href');
    if (id.startsWith('#')) {
      event.preventDefault();
      scrollToHash(id);
    }
  });
});

$(function () {
  if (typeof Lenis !== 'undefined') {
    const lenis = new Lenis({
      duration: 1.2,
      smooth: true
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
  } else {
    console.warn('Lenis が読み込まれていません');
  }
});


// ページ内スクロール用関数
function scrollToHash(id) {
  const target = document.querySelector(id);
  if (!target) return;
  gsap.to(window, {
    duration: 0.8,
    scrollTo: {
      y: target,
      offsetY: 100
    },
    ease: "power2.out"
  });
}




/*↓以下詳細ページのエントリーボタン押下でフォームラジオボタン選択*/
// ボタンクリック時にラジオボタンの値を保存（例：採用エントリー）
/*↓以下詳細ページのエントリーボタン押下でフォームラジオボタン選択*/
document.addEventListener('DOMContentLoaded', () => {
  // entryの data-radio 属性を持つ要素
  const radioButtons = document.querySelectorAll('#entry[data-radio]');

  radioButtons.forEach(button => {
    button.addEventListener('click', () => {
      const selectedValue = button.dataset.radio;
      if (selectedValue) {
        sessionStorage.setItem('presetRadio', selectedValue);
      }
    });
  });
});

// contact ページで保存されたラジオ値を使って初期選択を反映
document.addEventListener('DOMContentLoaded', () => {
  const presetValue = sessionStorage.getItem('presetRadio');

  if (presetValue) {
    const radioInputs = document.querySelectorAll('input[type="radio"][name="radio"]');

    radioInputs.forEach(input => {
      if (input.value === presetValue) {
        input.checked = true;
      }
    });

    sessionStorage.removeItem('presetRadio'); // 再選択防止のため削除
  }
});







//下層MV
document.addEventListener('DOMContentLoaded', () => {
  const mvCover = document.querySelector('.mv_cover');
  const bgMvTtls = document.querySelectorAll('.bg_mv_ttl');
  const otherTtlJa = document.querySelector('.other_ttl_ja');
  const topImage = document.querySelector('.other_top_inner img');

  // 初期状態
  gsap.set(mvCover, { y: '0%' });
  gsap.set(bgMvTtls, { x: '0%' });
  gsap.set(otherTtlJa, { opacity: 0 });
  gsap.set(topImage, { scale: 1.1 });

  const tl = gsap.timeline();

  // ① mv_cover を下にスライドして消す（ちょっと速く）
  tl.to(mvCover, {
    y: '150%',
    duration: 1.2,
    ease: 'power2.out'
  });

  // ② img のスケールアニメーション（もっと早く始める & durationも短く）
  tl.to(topImage, {
    scale: 1,
    duration: 0.8,
    ease: 'power2.out'
  }, '-=1.0'); // mv_cover の前半から被せてスタート

  // ③ 各 bg_mv_ttl を同時に流す
  tl.to(bgMvTtls, {
    x: '150%',
    duration: 1,
    ease: 'power2.out',
    stagger: 0.1
  }, '-=0.2');

  // ④ other_ttl_ja をフェードイン
  tl.to(otherTtlJa, {
    opacity: 1,
    duration: 0.2,
    ease: 'power2.out'
  }, '-=0.2');
});
